<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5">
                <div class="col-sm-12">
                    <vs-breadcrumb align="left" :items="
              [
                {title: 'You are here : '},
                {
                  title: 'Dashboard',
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: this.updateTraining.title,
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: 'Knowledge Base',
                  active: true
                }
              ]
                "></vs-breadcrumb>
                    <div class="heading mt-3">
                        <h3 class="text-secondary">Upload Training material</h3>
                    </div>

                    <div class="form-group form-row text-dark">
                        <h6 class="sub-frm-title">Event Information</h6>
                        <div class="row col-sm-12">
                            <label class="col-sm-1 font-weight-bold">Title:</label>

                            <div class="col-sm-11" v-if="updateTraining !=''">{{updateTraining.title}}</div>
                        </div>

                        <div class="row mt-5 col-sm-6">
                            <a href="#" class="pr-3 col-sm-4">
                                <vs-radio v-model="radios1" vs-value="Pre Training Form" style="color: #07a7e19c !important;">Pre Training</vs-radio>
                            </a>
                            <a href="#" class="pr-3 col-sm-4">
                                <vs-radio v-model="radios1" vs-value="In Training Form" style="color: #07a7e19c !important;">In Training</vs-radio>
                            </a>
                            <a href="#" class="pr-3 col-sm-4">
                                <vs-radio v-model="radios1" vs-value="Reference Material Form" style="color: #07a7e19c !important;">Reference Material</vs-radio>
                            </a>
                        </div>
                        <div class="modelx mt-3 col-sm-12">
                            <!-- Pre Training -->
                            <b-card v-if="isForm" style="border: 1px dotted #07a7e14f;">
                                <form @submit.prevent="uploadTrainingMaterial" enctype="multipart/form-data">
                                    <input type="hidden" v-model="training_id" />
                                    <div class="form-group form-row mb-0">
                                        <h6 class="sub-frm-title">
                                            <template v-if="radios1 === 'Pre Training Form'">Pre Training Form</template>
                                            <template v-if="radios1 === 'In Training Form'">In Training Form</template>
                                            <template v-if="radios1 === 'Reference Material Form'">Reference Material Form</template>
                                        </h6>
                                        <!-- <div class="row p-2"> -->
                                        <div class="table-responsive-sm" style="width:100%">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" style="color: #07a7e19c !important;">
                                                            Title
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </th>
                                                        <th scope="col" style="color: #07a7e19c !important;">
                                                            File Type
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </th>
                                                        <th scope="col" style="color: #07a7e19c !important;">
                                                            Upload
                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                        </th>
                                                        <th scope="col" style="color: #07a7e19c !important;">Link (Optional)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(item,index) in accademicArr">
                                                        <tr :key="index">
                                                            <td>
                                                                <div>
                                                                    <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" class="form-control" id="inputtext" v-model="materialTitle" placeholder />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <selectize id="select-state" v-model="select11" :settings="provinceSetting" :searchable="true">
                                                                        <option v-for="(item,index) in pretrainingmanualArr" :key="index" :value="item.value" :text="item.text">{{item.text}}</option>
                                                                    </selectize>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <b-form-file ref="file" type="file" name="filetoupload" v-on:change="handleFileUpload($event.target.files)" :state="Boolean(file)" placeholder="Choose a file..." drop-placeholder="Drop file here..."></b-form-file>
                                                                </div>
                                                                <!-- <input type="file" id="file" ref="file" v-on:change="handleFileUpload($event.target.files)" /> -->
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" v-model="materialink" class="form-control" id="inputtext" placeholder />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                    <div class="row justify-content-end mr-0">
                                        <b-button type="submit" class="save-btn d-flex justify-content-end" variant="primary">Save</b-button>
                                    </div>
                                </form>
                            </b-card>
                            <b-card v-if="isEditForm" style="border: 1px dotted #07a7e14f;">
                                <form @submit.prevent="updateTrainingMaterial" enctype="multipart/form-data">
                                    <input type="hidden" v-model="training_id" />
                                    <div class="form-group form-row mb-0">
                                        <h6 class="sub-frm-title">
                                            <template v-if="radios1 === 'Pre Training Form'">Pre Training Form</template>
                                            <template v-if="radios1 === 'In Training Form'">In Training Form</template>
                                            <template v-if="radios1 === 'Reference Material Form'">Reference Material Form</template>
                                        </h6>
                                        <!-- <div class="row p-2"> -->
                                        <div class="table-responsive-sm" style="width:100%">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Title</th>
                                                        <th scope="col">File Type</th>
                                                        <th scope="col">Upload</th>
                                                        <th scope="col">Link (Optional)</th>
                                                        <!-- <th scope="col">Actions</th> -->
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(item,index) in accademicArr">
                                                        <tr :key="index">
                                                            <td>
                                                                <div>
                                                                    <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" class="form-control" id="inputtext" v-model="materialTitle" placeholder />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <!-- <vs-select v-model="select11">
                                      <vs-select-item
                                        :key="index"
                                        :value="item.value"
                                        :text="item.text"
                                        v-for="(item,index) in pretrainingmanualArr"
                                      />
                                    </vs-select>-->
                                                                    <selectize id="select-state" v-model="select11" :settings="provinceSetting" :searchable="true">
                                                                        <option v-for="(item,index) in pretrainingmanualArr" :key="index" :value="item.value" :text="item.text">{{item.text}}</option>
                                                                    </selectize>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <b-form-file ref="file" type="file" name="filetoupload" v-on:change="handleFileUpload($event.target.files)" :state="Boolean(file)" placeholder="Choose a file..." drop-placeholder="Drop file here..."></b-form-file>

                                                                    <div v-if="select11 == 'PDF' || select11 == 'Word' || select11 == 'Html' || select11 == 'PPT'">
                                                                        <div class="otherMaterial_palceholder">{{uploadedFile}}</div>
                                                                    </div>
                                                                    <div v-if="select11 == 'Video'">
                                                                        <div class="vd-crd">
                                                                            <video controls>
                                                                                <source :src="BASEPATHDYNAMIC+'/'+uploadedFile" />
                                                                                <source :src="BASEPATHDYNAMIC+'/'+uploadedFile" />Your browser does not support HTML5 video.
                                                                            </video>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- <input type="file" id="file" ref="file" v-on:change="handleFileUpload($event.target.files)" /> -->
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <input style="line-height: 3;height: 36px;box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" v-model="materialink" class="form-control" id="inputtext" placeholder />
                                                                </div>
                                                            </td>
                                                            <td style="vertical-align: middle;">
                                                                <div>
                                                                    <!--  <vs-icon icon="add_box" style="color:#007bff;font-size:16px;cursor: pointer;"></vs-icon>
                          <vs-icon icon="edit" color="warning" style="font-size:16px"></vs-icon>
                                    <vs-icon icon="delete_forever" style="color:#ff0000c7;font-size:16px;cursor: pointer;"></vs-icon>-->
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                    <div class="row justify-content-end mr-0">
                                        <b-button type="submit" class="save-btn d-flex justify-content-end" variant="primary">Update</b-button>
                                        <b-button v-if="isEditForm" @click="closeEditForm" variant="outline-info" class="m-2">Cancel</b-button>
                                    </div>
                                    <input type="hidden" v-model="material_id" />
                                </form>
                            </b-card>
                            <div class="col-sm-12 p-0 mt-3">
                                <!-- new form popup starts -->
                                <b-card>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="table-responsive">http://localhost:9000/#/dashboard/program-officer/conductedTraining
                                                    <table class="table table-stripped">
                                                        <thead>
                                                            <tr>
                                                                <th>Title</th>
                                                                <th>Upload Type</th>
                                                                <th>File Type</th>
                                                                <th>Download</th>
                                                                <th>Created on</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(material,index) in materialRecords" :key="index">
                                                                <td class="text-capitalize">{{material.title}}</td>
                                                                <td class="text-capitalize">{{material.type}}</td>
                                                                <td>{{material.fileType}}</td>
                                                                <td>
                                                                    <a :href="BASEPATHDYNAMIC+'/'+material.uploadfile" target="_blank">
                                                                        <i class="material-icons" style="font-size:28px;color:#4285f4">get_app</i>
                                                                    </a>
                                                                </td>
                                                                <td>{{material.createdAt | formatDate}}</td>
                                                                <td>
                                                                    <a @click="editRecord(material.id)">
                                                                        <vs-icon class="mr-4" icon="edit" style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                    </a>
                                                                    <a @click="deleteRecord(material.id)">
                                                                        <vs-icon class="mr-1" icon="delete" style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"></vs-icon>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-card>
                                <!-- new form popup ends -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import Selectize from "vue2-selectize";

import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
export default {
    data: () => ({
        error: "",
        success: "",
        isSidebar: false,
        trainingDetails: [],
        trainingDates: [],
        training_id: "",
        filetoupload: null,
        accademicArr: 1,
        BASEPATHDYNAMIC: "",
        radios1: "Pre Training Form",
        popupActivo: false,
        activeItem: 0,

        file: "",
        material_id: "",
        search: "",
        errors: [],
        isForm: true,
        isEditForm: false,
        materialTitle: "",
        select11: "",
        materialink: "",
        isFormData: false,
        selected: "",
        subprogramSelected: "",
        subprogramsettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 3,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        imagesource: "",
        donerSelected: "",
        donersettings: {
            valueField: "code",
            labelField: "name",
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md
        contact_person: "",
        contact_number: "",
        uploadedFile: "",
        contact_email: "",
        address: "",
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        textarea: "",
        counterDanger: false,
        mydate: "",
        startDate: "",
        trainingId: "",
        trainingCode: "",
        updateTraining: [],
        materialRecords: [],
        endDate: "",
        colorx: "#1db952",
        indexActive: 0,
        trainingCheck: false,
        repeatedCheck: false,
        select1Normal: "",
        select1: 1,
        select2: 1,
        select3: 1,
        select4: 1,
        select5: 1,
        select6: 1,
        select7: 1,
        select8: 1,
        pretrainingmanualArr: [{
                text: "PDF",
                value: "PDF"
            },
            {
                text: "Word",
                value: "Word"
            },
            {
                text: "PPT",
                value: "PPT"
            },
            {
                text: "Video",
                value: "Video"
            },
            {
                text: "Image",
                value: "Image"
            }
        ]
    }),

    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingId = response.data.training.id;
                this.updateTraining = response.data.training;
                this.trainingMaterial(this.trainingId);
            });

        // Set the initial number of items
        // this.totalRows = this.items.length;
    },
    components: {
        Selectize,
        "app-navbar": Navbar,
        "app-sidebar": Sidebar
    },

    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        trainingMaterial: function trainingMaterial(tId) {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/traing_material/get/" +
                    JSON.parse(localStorage.getItem("currentUser")).id +
                    "/" + tId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.materials) {
                        this.materialRecords = response.data.materials;
                    }
                    if (response.data.trainingDetails) {
                        this.trainingDetails = response.data.trainingDetails;
                        if (response.data.trainingDetails.training) {
                            this.training_id = response.data.trainingDetails.training.id;
                            this.trainingDates = JSON.parse(
                                response.data.trainingDetails.training.TrainingDates
                            );
                        }
                    }
                });
        },
        uploadTrainingMaterial(e) {
            e.preventDefault();
            this.inValid = [];
            let self = this;

            if (!this.materialTitle) {
                this.inValid.push("Title is required.");
            }
            if (!this.radios1) {
                this.inValid.push("Material type is required.");
            }
            if (!this.select11) {
                this.inValid.push("File type is required.");
            }
            if (!this.file) {
                this.inValid.push("Please upload file.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append(
                    "user_id",
                    JSON.parse(localStorage.getItem("currentUser")).id
                );
                formData.append("title", this.materialTitle);
                formData.append("type", this.radios1);
                formData.append("fileType", this.select11);
                formData.append("training_id", this.trainingId);
                formData.append("link", this.materialink);
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/programofficer/upload/trainingmaterial",
                        formData
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);

                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.trainingMaterial();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        updateTrainingMaterial(e) {
            e.preventDefault();
            let self = this;
            this.inValid = [];
            if (!this.materialTitle) {
                this.inValid.push("Title is required.");
            }
            if (!this.radios1) {
                this.inValid.push("Material type is required.");
            }
            if (!this.select11) {
                this.inValid.push("File type is required.");
            }
            if (!this.file && this.uploadedFile == "") {
                this.inValid.push("Please upload file.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                let formData = new FormData();
                formData.append("file", this.file);
                formData.append("material_id", this.material_id);
                formData.append(
                    "user_id",
                    JSON.parse(localStorage.getItem("currentUser")).id
                );
                formData.append("title", this.materialTitle);
                formData.append("type", this.radios1);
                formData.append("fileType", this.select11);
                formData.append("link", this.materialink);
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH +
                        "/trainer/update/trainingmaterial",
                        formData
                    )
                    .then(response => {
                        if (response.data.unAuth) {
                            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);

                        }
                        if (response.data.tokenExpired) {
                            this.$toasted.global.errorMsg(response.data.tokenExpired);
                            localStorage.clear();
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 1000);
                        }
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been saved successfully!");
                            self.resetForm();
                            self.trainingMaterial();
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        closeEditForm() {
            this.isForm = true;
            this.isEditForm = false;
            (this.materialTitle = ""),
            (this.radios1 = ""),
            (this.select11 = ""),
            (this.file = ""),
            (this.materialink = "");
        },
        editRecord(id) {
            this.isForm = false;
            this.isEditForm = true;
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainingmaterial/" +
                    id +
                    "/edit"

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response) {
                        this.materialTitle = response.data.title;
                        this.radios1 = response.data.type;
                        this.select11 = response.data.fileType;
                        this.materialink = response.data.link;
                        this.uploadedFile = response.data.uploadfile;
                        this.material_id = response.data.id;

                        if (
                            this.select11 == "PDF" ||
                            this.select11 == "Word" ||
                            this.select11 == "Image" ||
                            this.select11 == "PPT"
                        ) {
                            this.uploadedFile = this.uploadedFile.substring(38, 100);
                        }
                    }
                });
        },
        deleteRecord(id) {
            // alert("ID '" +id+ "' is being deleted.");
            this.$bvModal
                .msgBoxConfirm("Please confirm that you want to delete?", {
                    title: "Please Confirm",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "Delete",
                    cancelTitle: "Cancel",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value == true) {
                        this.openLoading();
                        axios
                            .post(
                                process.env.VUE_APP_BASE_PATH + "/uploadmaterial/delete", {
                                    id: id
                                }
                            )
                            .then(response => {
                                this.closeLoading();
                                if (response.data.success) {
                                    this.success = "Record has been deleted successfully!";
                                    this.error = "";
                                    this.trainingMaterial();
                                } else if (response.data.error) {
                                    throw response.data.error;
                                }
                            })
                            .catch(error => {
                                this.success = "";
                                this.error = error;
                            });
                    }
                });
        },
        handleFileUpload(fileList) {
            this.file = fileList[0];
            // var FileSizeMb = this.file.size / Math.pow(1024, 2);
            if (this.select11 == "PDF") {
                if (this.file.type != "application/pdf") {
                    this.$toasted.global.errorMsg("Please Select PDF file");
                    this.file = "";
                }
            } else if (this.select11 == "Word") {
                if (
                    this.file.type != "application/msword" &&
                    this.file.type !=
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                ) {
                    this.$toasted.global.errorMsg("Please Select Word file");
                    this.file = "";
                }
            } else if (this.select11 == "PPT") {
                if (
                    this.file.type !=
                    "application/vnd.openxmlformats-officedocument.presentationml.presentation" &&
                    this.file.type != "application/vnd.ms-powerpoint"
                ) {
                    this.$toasted.global.errorMsg("Please Select PPT file");
                    this.file = "";
                }
            } else if (this.select11 == "Video") {
                if (this.file.type != "video/mp4" && this.file.type != "") {
                    this.$toasted.global.errorMsg("Please Select Video file");
                    this.file = "";
                }
            } else if (this.select11 == "Image") {
                if (
                    this.file.type != "image/jpeg" &&
                    this.file.type != "image/jpg" &&
                    this.file.type != "image/png"
                ) {
                    this.$toasted.global.errorMsg("Please Select Image with jpeg,jpg,png format");
                    this.file = "";
                }
            }
        },
        resetForm() {
            (this.materialTitle = ""),
            (this.radios1 = ""),
            (this.select11 = ""),
            (this.file = ""),
            (this.materialink = "");
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Files have been Uploaded, consectetur"
            });
        }
    }
};
</script>

<style>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.was-validated .custom-file-input:invalid~.custom-file-label,
.custom-file-input.is-invalid~.custom-file-label {
    border-color: #cecece;
}

.f-500 {
    font-weight: 500;
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.otherMaterial_palceholder {
    margin-top: 16px;
    background: #dedede;
    padding: 10px 0px 10px 0px;
    text-align: center;
}

.vd-crd {
    margin-top: 25px;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #f9f9f9;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

.vs-popup--background {
    opacity: 0.3 !important;
}

.con-img-upload .img-upload {
    width: 150px !important;
}

.add-btn {
    font-size: 25px;
    color: rgba(7, 167, 225, 0.61);
    cursor: pointer;
}

.delete-btn {
    font-size: 25px;
    color: rgba(255, 0, 0, 0.78);
    cursor: pointer;
}

th {
    border-bottom: none !important;
}
</style>
